{
  "title": "Zuweisungsregeln",
  "subtitle": "Von oben nach unten ausgewertet. Die erste passende Absenderregel gewinnt und die Auswertung endet.",
  "newRule": "Neue Regel",
  "testRules": "Absender testen",
  "loadError": "Regeln konnten nicht geladen werden",
  "emptyTitle": "Noch keine Regeln",
  "emptyBody": "Ohne Standard oder Regel wird nichts gestempelt: Jede Nachricht wird unverändert weitergeleitet. Legen Sie unter Benutzer eine Standard-Signatur fest oder fügen Sie hier eine engere Regel hinzu.",
  "tenantDefault": "Mandanten-Standard",
  "tenantDefaultHint": "Gilt, wenn keine Operatorregel passt.",
  "reorderError": "Regeln konnten nicht neu geordnet werden.",
  "reorderFailed": "Neuordnung fehlgeschlagen.",
  "deleteRule": "Regel löschen",
  "deleteConfirm": "„{{name}}“ löschen?",
  "deleted": "„{{name}}“ gelöscht.",
  "deleteError": "Regel konnte nicht gelöscht werden.",
  "editRule": "„{{name}}“ bearbeiten",
  "createRule": "Neue Regel",
  "ruleName": "Name",
  "ruleNamePlaceholder": "Vertrieb — externer Hinweis",
  "enabled": "Aktiviert",
  "disabled": "Deaktiviert",
  "template": "Vorlage",
  "injectionMode": "Einfügepfad",
  "injectionBoth": "Beide",
  "injectionBothPaths": "Beide Pfade",
  "injectionMailFlow": "Nur Mailflow",
  "injectionClient": "Nur Client",
  "injectionMailFlowShort": "Mailflow",
  "injectionClientShort": "Client",
  "unknownPath": "Unbekannter Pfad",
  "recipientScope": "Empfänger",
  "recipientAny": "Beliebig",
  "recipientAnyFull": "Beliebiger Empfänger",
  "recipientInternal": "Nur intern",
  "recipientExternal": "Nur extern",
  "unknownRecipients": "Unbekannte Empfänger",
  "recipientsHint": "Bewertet anhand der Envelope. Eine Nachricht ohne Empfänger erfüllt weder intern noch extern — eine eingeschränkte Regel trifft dann einfach nicht zu, statt zu raten.",
  "templateNew": "Signatur für neue Nachrichten",
  "templateNewShort": "Neu: {{name}}",
  "templateNewNone": "Neu: keine Vorlage",
  "templateReply": "Signatur für Antworten",
  "templateReplyShort": "Antwort: {{name}}",
  "templateReplySame": "Antwort: wie neu",
  "templateNone": "Keine",
  "templateReplyPlaceholder": "Wie bei neuen Nachrichten",
  "unknownTemplate": "Unbekannte Vorlage",
  "appliesTo": "Gilt für",
  "except": "Außer",
  "emptyScopeTitle": "Diese Regel trifft niemanden",
  "emptyScopeBody": "Ein leerer Bereich löst nie aus. Wählen Sie mindestens eine Facette oder aktivieren Sie Alle.",
  "emptyScopeBadge": "Trifft niemanden",
  "emptyScopeTooltip": "Ein leerer Absenderbereich trifft niemanden, daher löst diese Regel nie aus.",
  "hasExclusions": "Hat Ausschlüsse",
  "addExclusions": "Ausschlüsse hinzufügen",
  "removeExclusions": "Ausschlüsse entfernen",
  "exclusionsHint": "Ausgeschlossene Absender fallen auf Regeln mit niedrigerer Priorität durch, statt ihre Signatur ganz zu verlieren.",
  "saveRule": "Regel speichern",
  "saved": "Regel gespeichert.",
  "saveError": "Regel konnte nicht gespeichert werden",
  "testerTitle": "Absender testen",
  "testerHint": "Wählen Sie ein Postfach, um zu sehen, welche Regel gewinnt und welche Signatur gilt.",
  "senderAddress": "Absenderadresse",
  "senderPlaceholder": "jordan.avery@contoso.com.au",
  "recipientsLabel": "Empfänger",
  "recipientsDescription": "Envelope-Empfänger. Nur-interne und nur-externe Regeln werden daran gemessen.",
  "recipientsPlaceholder": "Empfänger hinzufügen und Enter drücken",
  "runTest": "Test ausführen",
  "testError": "Test konnte nicht ausgeführt werden",
  "noRuleMatched": "Keine Regel getroffen",
  "noRulesEvaluated": "Es wurden keine Regeln ausgewertet.",
  "colPriority": "Priorität",
  "colRule": "Regel",
  "colOutcome": "Ergebnis",
  "colWhy": "Warum",
  "traceMatched": "Getroffen",
  "traceShadowed": "Überlagert",
  "traceDisabled": "Deaktiviert",
  "traceSenderOutOfScope": "Absender außerhalb des Bereichs",
  "traceExcludedByRule": "Durch Regel ausgeschlossen",
  "traceRecipientScope": "Empfängerbereich",
  "traceWrongPath": "Falscher Pfad",
  "traceNotEvaluated": "Nicht ausgewertet",
  "traceUnknown": "Unbekannt",
  "excludedTitle": "Absender ist ausgeschlossen",
  "excludedBody": "Diese Adresse ist im Verzeichnis als ausgeschlossen markiert, daher wird ihre Post unberührt weitergeleitet und keine Regel ausgewertet. Es gibt nichts zu verfolgen.",
  "excludedHint": "Der Ausschluss wird am Verzeichnisbenutzer gesetzt, nicht in diesen Regeln. Heben Sie ihn dort auf, wenn dieser Absender gestempelt werden soll.",
  "primaryDefault": "Primärer Standard",
  "defaultBadge": "Standard",
  "everyone": "Alle",
  "noMailboxesCovered": "Noch keine Postfächer abgedeckt.",
  "mailboxesCovered": "{{count}} Postfach abgedeckt.",
  "mailboxesCovered_other": "{{count}} Postfächer abgedeckt.",
  "mailboxesCoveredWithCustom": "{{count}} Postfach abgedeckt, {{custom}} mit individueller Signatur.",
  "mailboxesCoveredWithCustom_other": "{{count}} Postfächer abgedeckt, {{custom}} mit individueller Signatur.",
  "managedOnUsers": "Verwaltet auf der",
  "usersTab": "Registerkarte Benutzer",
  "changeDefault": "Standard ändern",
  "reorderAria": "{{name}} neu ordnen",
  "moreActionsAria": "Weitere Aktionen für {{name}}",
  "edit": "Bearbeiten",
  "facetEveryone": "Alle",
  "facetUsers": "Benutzer",
  "facetGroups": "Gruppen",
  "facetDomains": "Domänen",
  "facetConditions": "Bedingungen",
  "everyoneLabel": "Auf alle im Mandanten anwenden",
  "everyoneDescription": "Der explizite Catch-all. Ohne ihn trifft ein Bereich ohne andere Facette niemanden.",
  "directoryUsers": "Verzeichnisbenutzer",
  "searchUsers": "Benutzer suchen",
  "userExcludedSuffix": " (ausgeschlossen)",
  "emailAddresses": "E-Mail-Adressen",
  "emailAddressesDescription": "Gegen jede Proxy-Adresse geprüft, sodass auch Aliase und freigegebene Postfächer auflösen.",
  "emailAddressesPlaceholder": "name@beispiel.com",
  "groupsLabel": "Gruppen",
  "searchGroups": "Gruppen suchen",
  "groupsDescription": "Verschachtelte Mitgliedschaft wird bei der Synchronisierung abgeflacht, sodass ein Benutzer in einer Untergruppe passt.",
  "senderDomains": "Absenderdomänen",
  "senderDomainsDescription": "Gegen den Domänenteil der Absenderadresse geprüft.",
  "senderDomainsPlaceholder": "contoso.com.au",
  "conditionsEmptyHint": "Keine Attributbedingungen. Fügen Sie eine hinzu, um nach Abteilung, Büro oder einem benutzerdefinierten Attribut zu filtern.",
  "facetsUnionHint": "Facets werden als Vereinigung kombiniert: jeder, der zu einer Facette passt, ist im Bereich.",
  "match": "Übereinstimmung",
  "attribute": "Attribut",
  "usersHaveValue": "{{count}} Benutzer haben einen Wert",
  "attributeNotSeen": "Bei keinem synchronisierten Benutzer gesehen",
  "value": "Wert",
  "valueInPlaceholder": "Vertrieb, Marketing",
  "removeCondition": "Bedingung entfernen",
  "addCondition": "Bedingung hinzufügen",
  "operatorEquals": "ist",
  "operatorNotEquals": "ist nicht",
  "operatorContains": "enthält",
  "operatorStartsWith": "beginnt mit",
  "operatorEndsWith": "endet mit",
  "operatorIsEmpty": "ist leer",
  "operatorIsNotEmpty": "ist nicht leer",
  "operatorIn": "ist eines von"
}
